import { SpintrTypes } from "src/typings";
import { isDateInDaysOfWeek } from "src/utils";
import { QualityHubTasksListLocalChanges } from "./QualityHubTasksList/QualityHubTasksList.types";

/**
 * Applies filtering, pending changes, and sorting to tasks for a specific group
 */
export function getFilteredTasksForGroup(
    groupId: number | null,
    taskList: Spintr.TaskList | undefined,
    pendingTaskChanges: QualityHubTasksListLocalChanges,
    hideDisabledItems: boolean,
    listMode: Spintr.QualityHubTasksListMode = SpintrTypes.QualityHubTasksListMode.Execution,
): Spintr.TaskListTask[] {
    if (!taskList?.tasks) {
        return [];
    }

    const now = new Date();
    const editMode = 
        listMode === SpintrTypes.QualityHubTasksListMode.Customization ||
        listMode === SpintrTypes.QualityHubTasksListMode.Creation;

    const tasks = taskList.tasks.map((task) => {
        const pendingChanges = pendingTaskChanges.tasks.get(task.id);
        if (pendingChanges) {
            return {
                ...task,
                ...pendingChanges,
            };
        }
        return task;
    });

    // Get tasks for the specific group
    let filteredTasks = tasks.filter((task) => {
        // Filter by group ID
        if (groupId === null) {
            return !task.groupId; // Groupless tasks
        } else {
            return task.groupId === groupId;
        }
    });

    // Apply day of week filtering (unless in edit mode)
    if (!editMode) {
        filteredTasks = filteredTasks
            .filter((task) => !task.daysOfWeek || isDateInDaysOfWeek(now, task.daysOfWeek))
            .filter((task) => task.contentStatus === SpintrTypes.ContentStatus.Published);
    }

    // Sort by sortOrder (which may include pending changes)
    filteredTasks.sort((a, b) => {
        const aOrder = a.sortOrder ?? 0;
        const bOrder = b.sortOrder ?? 0;
        return aOrder - bOrder;
    });

    // Filter out disabled/deleted items based on mode and settings
    if (!editMode || hideDisabledItems) {
        filteredTasks = filteredTasks.filter((task) => !(task.contentStatus === SpintrTypes.ContentStatus.Deleted));
    }

    return filteredTasks;
}
